<fxch-sidebar [isExpanded]="sidebarExpanded" (toggleSidebar)="toggle()"></fxch-sidebar>
<div class="content" [ngClass]="{ 'sidebarExpanded': sidebarExpanded, 'sidebarClosed': !sidebarExpanded }">
  <router-outlet></router-outlet>
</div>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
